(function () {
  try {
    document.querySelectorAll('[data-ek-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-ek-track]');
      rail.querySelectorAll('.ekr__arrow').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8 * Number(b.dataset.dir), behavior: 'smooth' }); });
      });
    });
    document.querySelectorAll('[data-ek-tabs]').forEach(function (sec) {
      var tabs = sec.querySelectorAll('.ekt__tab');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-selected', 'false'); });
          t.classList.add('is-on'); t.setAttribute('aria-selected', 'true');
          sec.querySelectorAll('.ekt__panel').forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.tab; });
        });
      });
    });
  } catch (e) {}
})();
(function () {
  try {
    var vids = document.querySelectorAll('.ekh__vid[data-ek-src]');
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.src) { v.src = v.dataset.ekSrc; }
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          v.classList.add('is-on');
        } else { v.pause(); }
      });
    }, { rootMargin: '80px' });
    vids.forEach(function (v) { v.addEventListener('playing', function () { v.classList.add('is-playing'); }); io.observe(v); });
  } catch (e) {}
})();
